'use client';

import "@/styles/libs/arrow-animation.css";
import '@/styles/libs/swiper-overrides.css';
import cn from 'classnames';
import Link from 'next/link';
import { FC } from 'react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from 'swiper/react';
import { CustomerStoryGridItem, CustomerStoryGridItemProps } from './CustomerStoryGridItem';
import { DesktopCustomerStoryTestimonial } from './DesktopCustomerStoryTestimonial';
import { MobileCustomerStoryTestimonial } from './MobileCustomerStoryTestimonial';

export type CustomerStoriesGridProps = {
  hideComponent?: boolean;
  title: React.ReactNode;
  cta: {
    href: string;
    title: string;
  };
  gridItems: CustomerStoryGridItemProps[];
  testimonials: CustomerStoryTestimonialProps[];
}

export type CustomerStoryTestimonialProps = {
  logo: React.ReactNode;
  quote: string;
  author: string;
  title: string;
}

const CustomerStoriesGrid: FC<CustomerStoriesGridProps> = ({
  hideComponent = false,
  title,
  gridItems = [],
  testimonials = [],
  cta,
}) => {
  if (hideComponent) return null;
  return (
    <div
      className={cn(hideComponent ? 'hidden' : 'flex',
        'bg-white-100 px-container-mobile md:px-container-desktop py-[120px]'
      )}
    >
      <div className="mx-auto max-w-grid w-full flex flex-col gap-6">
        <div className="flex flex-col justify-center items-center">
          <h3 className="text-center text-pretty text-30/35 md:text-display3 sm:max-w-68 md:max-w-85 font-500 tracking-tight">{title}</h3>
          <div className="mt-4 flex items-center hover-arrow-wrapper">
            <div className="flex font-500 text-blue-1000 text-p2 w-full">
              <Link
                className="font-500 text-blue-900 text-p2"
                href={cta.href}
              >   {cta.title}</Link>
            </div>
            <div className="flex ml-[8px] relative w-[16px] h-[16px] bg-[url(https://front.com/webassets/rebrand/black-right-arrows.png)] hover-arrow" />
          </div>

        </div>
        {/* Desktop Cards & Testimonial */}
        <div className="hidden md:grid md:grid-cols-3 md:grid-rows-3 xl:grid-cols-4 xl:grid-rows-2 md:gap-x-0 gap-y-0">
          {gridItems.map((item) => (
            <CustomerStoryGridItem key={item.href} {...item} />
          ))}
          <div className="block p-1 row-start-3 md:col-span-3 xl:row-start-2 xl:col-span-2 xl:col-start-2  bg-transparent relative  rounded-[12px]">
            <DesktopCustomerStoryTestimonial testimonials={testimonials} />
          </div>
        </div>
        {/* Mobile Cards */}
        <div className="md:hidden -mx-3 p-0 col-span-2 col-start-2 row-start-2 bg-transparent relative  rounded-[12px]">
          <Swiper slidesPerView={1.25} loop={true} centeredSlides={true} centeredSlidesBounds={true} spaceBetween={0}>
            {gridItems.map((item) => (
              <SwiperSlide key={item.href}>
                <CustomerStoryGridItem key={item.href} {...item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* Mobile Testimonial */}
        <MobileCustomerStoryTestimonial testimonials={testimonials} />
      </div>
    </div>
  );
};

export default CustomerStoriesGrid;
